<template lang="pug">
  .leads
    .background-header.white
      v-container.pb-0.white(style="max-width: 600px")
        div.my-2.mx-2
          v-text-field(v-model="searchText" hide-details dense outlined background-color="basic200" height="40" :placeholder="$t('search_customers')")
            template(v-slot:append)
              eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
      v-container.pa-0.main-container(style="max-width: 600px")
        v-tabs(v-model="selectedFilter" fixed-tabs color="textColorAccent" height="40")
          v-tab.button-AA-medium {{ $t('all') }}
          v-tab.button-AA-medium {{ $t('paid') }}
          v-tab.button-AA-medium {{ $t('unpaid') }}
        div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")
    v-container.white.py-2.px-4(style="max-width: 600px")
      v-layout
        div(style="width: 36px")
          y-checkbox.pa-0.mx-0(style="margin-top: 9px;" v-model="selectAll")
        v-btn.label.px-0(color="transparent" text @click="showDetails = !showDetails")
          v-icon.mr-1(color="primary400" size="15") {{ showDetails ? 'mdi-table-eye-off' : 'mdi-table-eye' }}
          div.primary400--text {{ showDetails ? $t('hide_details') : $t('show_details') }}
        v-spacer
        template(v-if="selectedLeads.length > 0")
          v-menu(offset-y)
            template(v-slot:activator="{ on }")
              v-btn.label.px-0.mr-2(color="transparent" text v-on="on")
                eva-icon.mt-1.mr-1(name="external-link-outline" :fill=" $vuetify.theme.themes[$theme].textColorAccent" width="14")
                div.textColorAccent--text {{ $t('actions') }}
            v-list(dense)
              v-menu(v-if="selectedLeads.reduce((a, b) => { if (!a.includes(b.paid.toString())) a.push(b.paid.toString()); return a }, []).length === 1")
                template(v-slot:activator="{ on, attrs }")
                  v-list-item(v-on="on" v-bind="attrs")
                    v-list-item-title.s2.basic800--text {{ $t('update_selected') }}
                v-list(dense)
                  template(v-if="selectedLeads[0].paid")
                    template(v-for="stat in paidStatusSelections")
                      v-list-item(:key="stat.id" @click="updateStatus(stat)")
                        v-list-item-title.s2.basic800--text {{ stat.name }}
                  template(v-else)
                    template(v-for="stat in statusSelections")
                      v-list-item(:key="stat.id" @click="updateStatus(stat)")
                        v-list-item-title.s2.basic800--text {{ stat.name }}
              v-list-item(@click="exportCsv")
                v-list-item-title.s2.basic800--text {{ $t('export_selected') }}
              v-list-item(@click="openDeleteDialog = true")
                v-list-item-title.s2.basic800--text {{ $t('delete_selected') }}
        template(v-else)
          v-btn.label.px-0.mr-2(color="transparent" text @click="exportCsv")
            eva-icon.mt-1.mr-1(name="external-link-outline" :fill=" $vuetify.theme.themes[$theme].primary400" width="14")
            div.primary400--text export
        v-btn.label.px-0(color="transparent" text @click="filterSheet = true")
          eva-icon.mt-1.mr-1(name="options-2-outline" :fill=" $vuetify.theme.themes[$theme].primary400" width="14")
          div.primary400--text {{ $t('filter') }}

    v-container.py-2.px-0(v-if="Object.keys(filteredData).length > 0" :style="`max-width: 600px; background-color: ${$vuetify.theme.themes[$theme].basic600T08} !important`")
      div.scrolling-wrapper
        v-chip.ml-1(v-if="selectedStatusFilter" color="basic600" close outlined close-icon="mdi-close" small @click:close="selectedStatusFilter = null; searchItem()") {{ selectedStatusFilter.name }}
        v-chip.ml-1(v-if="selectedCustomLabelFilter" color="basic600" close outlined close-icon="mdi-close" small @click:close="selectedCustomLabelFilter = null; searchItem()") {{ selectedCustomLabelFilter.name }}
        v-chip.ml-1(v-if="selectedSalespersonFilter" color="basic600" close outlined close-icon="mdi-close" small @click:close="selectedSalespersonFilter = null; searchItem()") {{ selectedSalespersonFilter.name }}
        v-chip.ml-1(v-if="selectedSourceFilter" color="basic600" close outlined close-icon="mdi-close" small @click:close="selectedSourceFilter = null; searchItem()") {{ selectedSourceFilter.name }}
        v-chip.ml-1(v-if="selectedProductFilter" color="basic600" close outlined close-icon="mdi-close" small @click:close="selectedProductFilter = null; searchItem()") {{ selectedProductFilter.name }}
        v-chip.ml-1(v-if="selectedCouponFilter" color="basic600" close outlined close-icon="mdi-close" small @click:close="selectedCouponFilter = null; searchItem()") {{ selectedCouponFilter.name }}
        v-chip.ml-1(v-if="selectedDateRangeFilter" color="basic600" close outlined close-icon="mdi-close" small @click:close="selectedDateRangeFilter = null; selectedDateRange = null; searchItem()")
          template(v-if="selectedDateRangeFilter.id === 'custom' && selectedDateRange.length > 0")
            template(v-if="selectedDateRange.length > 1") {{ selectedDateRange[0] | humanizeDate }} ~ {{ selectedDateRange[1] | humanizeDate }}
            template(v-else) {{ selectedDateRange[0] | humanizeDate }}
          template(v-else) {{ selectedDateRangeFilter.name }}
        span.ml-1
    v-container.pa-0.mb-4(style="max-width: 600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content-layout(v-else)
        v-layout.my-6(v-if="leads.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption {{ $t('no_customer_found') }}
        template(v-else v-for="(lead, index) in leads")
          database-item.white.px-3(:key="lead.id" :index="index" :parentLead.sync="lead" :selectAll="selectAll" :showDetails="showDetails" @deleted="handleDeleteItem" :company="company" @edited="handleEditItem")
          v-divider.basic300
      y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")

    .modals
      filter-database-sheet(v-if="filterSheet" :company="company" :role="member.role" :filtered="filteredData" :open.sync="filterSheet" @filtered="handleFiltered")
      y-dialog(v-if="openUpdateStatusDialog" v-model='openUpdateStatusDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('update_status') }}
          v-card-text.p2.primary500--text.px-4
            div {{ $t('update_status_description') }}
              strong  {{ newStatus.name }}?
          v-card-actions
            v-spacer
            v-btn(color='white', text @click="openUpdateStatusDialog = false; newStatus = {}")
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='textColorAccent' depressed height=32 @click='startUpdate' :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('update') }}

      y-dialog(v-if="openDeleteDialog" v-model='openDeleteDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_items') }}
          v-card-text.p2.primary500--text.px-4
            div(v-if="selectedLeads.length > 1") {{ $t('delete_items_description', { text: 'these items? These items'} ) }}
            div(v-else) {{ $t('delete_items_description', { text: 'this item? This item'} ) }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete' :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('delete') }}
</template>

<script>
import { mapState, mapActions } from 'vuex'
import queryString from 'query-string'
import DatabaseItem from '@/components/crm/RenewalItem.vue'
import FilterDatabaseSheet from '../database/FilterDatabaseSheet.vue'

export default {
  name: 'Database',
  components: { DatabaseItem, FilterDatabaseSheet },
  props: ['company'],
  data () {
    return {
      isFetching: false,
      isFetchingPotentialSales: false,
      pageSize: 10,
      page: 1,
      count: 0,
      searchText: '',
      leads: [],
      searchCountDown: null,
      selectedFilter: 0,
      searchfilter: '',
      selectedDateRange: [],
      selectedDateRangeFilter: null,
      customDateRangePickerDialog: false,
      openFormFilterDialog: false,
      selectedSourceFilter: null,
      selectedCouponFilter: null,
      openMemberFilterDialog: false,
      selectedSalespersonFilter: null,
      openProductFilterDialog: false,
      openDeleteDialog: false,
      openUpdateStatusDialog: false,
      newStatus: {},
      selectedProductFilter: null,
      selectedStatusFilter: null,
      selectedCustomLabelFilter: null,
      selectAll: false,
      filterSheet: false,
      showDetails: false,
      isLoading: false,
      loadingCount: 0,
      totalLoadingCount: 0,
      potentialSales: null,
      filters: [
        {
          text: '3 Days',
          value: ''
        },
        {
          text: '30 Days',
          value: ''
        },
        {
          text: '60 Days',
          value: ''
        }
      ],
      statusSelections: [
        { name: 'New', id: 'new' },
        { name: 'Follow up', id: 'follow_up' },
        { name: 'Partial payment', id: 'partial_payment' },
        { name: 'Reject', id: 'reject' }
      ],
      paidStatusSelections: [
        { name: 'Processed', id: 'processed' },
        { name: 'Shipped', id: 'shipped' },
        { name: 'Received', id: 'received' },
        { name: 'Cancelled', id: 'cancelled' }
      ]
    }
  },
  computed: {
    ...mapState('user', ['user', 'member']),
    filterParams () {
      let params = {
        form__company: this.company.id,
        page: 1,
        form_type: 'shopify',
        page_size: this.pageSize,
        paid: this.searchfilter,
        ordering: '-record_date,-rid'
      }

      // Add date filtering based on the selected tab
      const today = new Date();
      let startDate = new Date();
      let endDate = new Date();

      if (this.selectedFilter === 0) { // 3 Days
        endDate.setDate(today.getDate() + 3);
        startDate.setDate(today.getDate()-60);
      } else if (this.selectedFilter === 1) { // 30 Days
        endDate.setDate(today.getDate() + 30);
        startDate.setDate(today.getDate() + 3);
      } else if (this.selectedFilter === 2) { // 60 Days
        endDate.setDate(today.getDate() + 60);
        startDate.setDate(today.getDate() + 30);
      }

      // Format the date to YYYY-MM-DD
      const formatDate = (date) => date.toISOString().split('T')[0];

      params.date__gte = formatDate(startDate);
      params.date__lte = formatDate(today);

      if (this.searchText && this.searchText.length >= 2 && this.searchText.includes('#')) {
        params.rid = this.searchText.replace('#', '')
      } else if (this.searchText) {
        params.search = this.searchText
      }
      if (this.member.role !== 'Admin') {
        params.member = this.member.id
      }
      if (this.selectedStatusFilter) {
        params.status = this.selectedStatusFilter.id
      }
      if (this.selectedCustomLabelFilter) {
        params.custom_label = this.selectedCustomLabelFilter.id
      }
      if (this.selectedSourceFilter) {
        params.form = this.selectedSourceFilter.id
      }
      if (this.selectedCouponFilter) {
        params.coupon_code = this.selectedCouponFilter.id
      }
      if (this.selectedSalespersonFilter) {
        params.member = this.selectedSalespersonFilter.id
      }
      if (this.selectedProductFilter) {
        params.product = this.selectedProductFilter.id
      }
      if (this.selectedDateRangeFilter) {
        if (this.selectedDateRangeFilter.id === 'custom') {
          if (this.selectedDateRange.length === 1) {
            params.created_after = this.selectedDateRange[0]
            params.created_before = this.selectedDateRange[0]
          } else {
            if (this.selectedDateRange[0] < this.selectedDateRange[1]) {
              params.created_after = this.selectedDateRange[0]
              params.created_before = this.selectedDateRange[1]
            } else {
              params.created_after = this.selectedDateRange[1]
              params.created_before = this.selectedDateRange[0]
            }
          }
        } else {
          params.range = this.selectedDateRangeFilter.id
        }
      }
      params.ids = this.leads.reduce((result, lead)=> {return lead.selected ? result+lead.id + ',' : result}, '')
      return params
    },
    filteredData () {
      let data = {}
      this.selectedSourceFilter ? data.source = this.selectedSourceFilter : null
      this.selectedCouponFilter ? data.coupon = this.selectedCouponFilter : null
      this.selectedSalespersonFilter ? data.salesperson = this.selectedSalespersonFilter : null
      this.selectedProductFilter ? data.product = this.selectedProductFilter : null
      this.selectedStatusFilter ? data.status = this.selectedStatusFilter : null
      this.selectedCustomLabelFilter ? data.customLabel = this.selectedCustomLabelFilter : null
      this.selectedDateRangeFilter ? data.range = this.selectedDateRangeFilter : null
      this.selectedDateRangeFilter ? data.selectedDateRange = this.selectedDateRange : null
      return data
    },
    selectedLeads () {
      return this.leads.filter(f => f.selected)
    }
  },
  mounted () {
    if (!this.$route.query.page) {
      this.fetchLeads(1)
    } else {
      this.fetchLeads(this.$route.query.page)
    }
    if (this.$route.query.tab == 'unpaid') {
      this.selectedFilter = 2
    }
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchLeads(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
        if (this.selectedFilter === 2) {
          this.getPotentialSales()
        }
      }, 500)
    },
    selectedFilter(val) {
      const filter = this.filters[val]
      this.searchfilter = filter.value
      this.searchItem()
      if (this.selectedFilter === 2) {
        this.getPotentialSales()
      }
    },
    loadingCount (val) {
      if (val) {
        if (val === this.totalLoadingCount) {
          this.isLoading = false
          this.openUpdateStatusDialog = false
          this.openDeleteDialog = false
          this.newStatus = {}
          this.totalLoadingCount = 0
        }
      }
    },
    totalLoadingCount (val) {
      if (!val) {
        this.loadingCount = 0
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchLeads(page) {
      this.page = parseInt(page)
      this.isFetching = true
      const today = new Date();
      let startDate = new Date();
      let endDate = new Date();

      startDate.setDate(today.getDate() - 4);
      endDate.setDate(today.getDate());
      let queryString = Object.keys(this.filterParams).filter((key) => key !== 'page').map(key => key + '=' + this.filterParams[key]).join('&')
      let url = `/leads/?form_type=shopify&page=${page}&${queryString}`
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.leads = response.data.results
        this.count = response.data.count
      })
      .catch(() => {})
    },
    getPotentialSales () {
      this.isFetchingPotentialSales = true
      let queryString = Object.keys(this.filterParams).filter((key) => key !== 'page').filter((key) => key !== 'page_size').map(key => key + '=' + this.filterParams[key]).join('&')
      let url = `/leads/abandoned_cart/?abandoned_checkout=true&${queryString}`
      this.$axios.get(url)
        .then(resp => {
          this.potentialSales = resp.data
          this.isFetchingPotentialSales = false
        })
    },
    searchItem () {
      this.isFetching = true
      this.page = 1
      this.$axios.get('/leads/', { params: this.filterParams })
        .then((response) => {
          this.isFetching = false
          this.leads = response.data.results
          this.count = response.data.count
        })
        .catch(() => {})
    },
    clickOpenInvoice (invoice) {
      this.currentOpenInvoice = invoice
      this.openInvoiceDialog = true
    },
    handleDeleteItem (item) {
      this.leads = this.leads.filter((x) => x !== item)
    },
    handleEditItem (item) {
      let editIndex = 0
      this.leads.forEach((lead, index) => {
        if (lead.id === item.id) {
          editIndex = index
        }
      })
      this.leads = this.leads.filter((x) => x.id !== item.id)
      this.leads.splice(editIndex, 0, item)
    },
    handleFiltered (data) {
      this.selectedSourceFilter = data.source || null
      this.selectedCouponFilter = data.coupon || null
      this.selectedSalespersonFilter = data.salesperson || null
      this.selectedProductFilter = data.product || null
      this.selectedStatusFilter = data.status || null
      this.selectedCustomLabelFilter = data.customLabel || null
      this.selectedDateRangeFilter = data.range || null
      if (data.range) {
        this.selectedDateRange = data.selectedDateRange
      }
      this.searchItem()
    },
    exportCsv () {
      let queryString = Object.keys(this.filterParams).map(key => key + '=' + this.filterParams[key]).join('&')
      let exportDomain = 'https://export-test.yezza.io'
      if (process.env.VUE_APP_ENV === 'prod') {
        exportDomain = 'https://export.yezza.io'
      }
      this.$axios.post(`/users/${this.user.id}/request_otk/`)
        .then(response => {
          const exportUrl = `${exportDomain}/leads/export_csv/?${queryString}&key=${response.data.key}`
          if (this.$isMobile) {
            window.open(exportUrl)
          } else {
            location.href = exportUrl
          }
        })
        .catch(() => {})
    },
    updateStatus (stat) {
      this.openUpdateStatusDialog = true
      this.newStatus = stat
    },
    startUpdate () {
      this.isLoading = true
      this.totalLoadingCount = this.selectedLeads.length
      this.selectedLeads.forEach(o => {
        let data = { status: this.newStatus.id }
        this.axios.patch(`/leads/${o.pid}/`, data)
          .then(resp => {
            this.leads.filter(f => f.id === o.id)[0].status = resp.data.status
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.loadingCount++
          })
      })
    },
    startDelete () {
      this.isLoading = true
      this.totalLoadingCount = this.selectedLeads.length
      this.selectedLeads.forEach(o => {
        let data = { status: 'deleted' }
        this.axios.patch(`/leads/${o.pid}/`, data)
          .then(resp => {
            this.leads = this.leads.filter(x => x.id !== resp.data.id)
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.loadingCount++
          })
      })
    }
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
}
</style>

<i18n>
{
  "en": {
    "search_customers": "Search customers",
    "potential_sales": "Potential sales",
    "all": "3 Days",
    "paid": "30 Days",
    "unpaid": "60 Days",
    "show_details": "Show details",
    "hide_details": "Hide details",
    "actions": "actions",
    "update_selected": "Update Selected",
    "export_selected": "Export Selected",
    "delete_selected": "Delete Selected",
    "update_status_description": "Are you sure you want to change the selected customer status to",
    "delete_items": "Delete Items",
    "delete_items_description": "Are you sure you want to delete {text} will be deleted permanently."
  },
  "id": {
    "search_customers": "Cari pelanggan",
    "potential_sales": "Potential sales",
    "all": "3 Hari",
    "paid": "30 Hari",
    "unpaid": "60 Hari",
    "show_details": "tampilkan detail",
    "hide_details": "sembunyikan detail",
    "actions": "Tindakan",
    "update_selected": "Perbarui",
    "export_selected": "Export",
    "delete_selected": "Hapus",
    "update_status_description": "Anda yakin ingin mengubah status pelanggan ke",
    "delete_items": "Hapus item",
    "delete_items_description": "Apakah kamu yakin ingin menghapus {text} akan dihapus secara permanen."
  }
}
</i18n>